<template>
    <div>
        <md-dialog :md-fullscreen="false"
                   :md-active.sync="makeOffer"
                   :md-click-outside-to-close="false">
            <md-dialog-title>Make a loan offer</md-dialog-title>
            <md-dialog-content>
                <p class="has-text-centered">Contact {{borrFirstN}}</p>
                <b-button class="btn" tag="a" :href='`tel:${borrTel}`' expanded>
                    <md-icon>phone</md-icon> Call {{borrFirstN}}
                </b-button>
                <b-button class="btn" tag="a" :href='`sms://${borrTel}`' expanded>
                    <md-icon>textsms</md-icon> Send SMS
                </b-button>
            </md-dialog-content>
            <md-dialog-actions>
                <md-button class="md-primary" @click="$emit('update:makeOffer', false)">Close</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import BButton from "buefy/src/components/button/Button";
    export default {
        name: "loan-offer",
        components: {BButton},
        props: ['makeOffer', 'borrFirstN', 'borrTel']
    }
</script>

<style scoped>
.btn {
    margin: 12px 0;
    height: 48px;
}
</style>